import { render, staticRenderFns } from "./DialogOrdenarHijos.vue?vue&type=template&id=c4cba23e&scoped=true"
import script from "./DialogOrdenarHijos.vue?vue&type=script&lang=js"
export * from "./DialogOrdenarHijos.vue?vue&type=script&lang=js"
import style0 from "./DialogOrdenarHijos.vue?vue&type=style&index=0&id=c4cba23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cba23e",
  null
  
)

export default component.exports